// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root level containment */
html, body {
  position: relative;
  width: 100vw;
  height: 100%;
  margin: 0;
  padding: 0;
  -webkit-text-size-adjust: 100%;
}

/* Container styles */
.course-page {
  width: 100%;
  max-width: 100%;
  padding: 20px;
  margin: 0 auto;
  background-color: #013020;
  box-shadow: none;
  border: none;
  box-sizing: border-box;
  touch-action: pan-y pinch-zoom;
  -webkit-overflow-scrolling: touch;
}

/* Header styles */
.course-page header {
  text-align: left;
  margin-bottom: 20px;
  width: 100%;
}

.course-page header h1 {
  font-size: 2.8rem;
  color: #ffffff;
  margin-bottom: 10px;
  text-align: left;
}

.course-page header h2 {
  font-size: 2.0rem;
  color: #ffffff;
  margin: 10px 0;
}

.course-page header p {
  font-size: 1.0rem;
  color: #e3e3e3;
  margin: 5px 0;
}

.course-page header .units-description {
  font-size: 1.2rem;
  color: #5e5e5e;
  margin: 5px 0;
}

/* Content styles */
.prerequisite,
.corequisite {
  font-size: 1.1rem;
  color: #e3e3e3;
  margin: 10px 0;
  padding: 10px;
  background-color: #1b232b;
  border-left: 4px solid #f2cd01;
}

.gpa {
  color: #f2cd01;
  margin: 5px 0;
  font-weight: bold;
}

/* Main layout */
.course-page main {
  margin-top: 20px;
  background-color: #013020;
  padding: 20px;
  border-radius: 8px;
}

.course-page section {
  margin-bottom: 30px;
  background-color: #013020;
  padding: 20px;
  border-radius: 8px;
}

.course-page section h2 {
  font-size: 1.5rem;
  color: #ffffff;
  border-bottom: 2px solid #f2cd01;
  padding-bottom: 10px;
  margin-bottom: 15px;
}

/* Table styles */
.table-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  position: relative;
  margin: 0;
  padding: 0;
}

.data-table {
  width: max-content;
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 20px;
  background-color: #013020;
  text-align: center;
}

.data-table th,
.data-table td {
  border: 1px solid #ffffff;
  padding: 12px 15px;
  text-align: center;
  font-size: 0.9rem;
  color: #e3e3e3;
  vertical-align: middle;
}

.data-table th {
  background-color: #013020;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 10;
}

.data-table tr:nth-child(even) {
  background-color: #178445;
}

.data-table tr {
  touch-action: pan-y;
}

.data-table button {
  background-color: #f2cd01;
  color: #ffffff;
  padding: 5px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  touch-action: manipulation;
}

.data-table button:hover {
  background-color: #ff851b;
}

.data-table td a {
  color: #fff700;
  text-decoration: underline;
}

.data-table td a:hover {
  text-decoration: underline;
}

/* Details container styles */
.details-row {
  background-color: #265d38;
}

.details-container {
  padding: 0;
  height: 0;
  overflow: hidden;
  transition: height 0.5s ease-out, padding 0.3s ease-out;
  background-color: #265d38;
  opacity: 0;
}

.details-container.expanded {
  opacity: 1;
  transition: height 0.5s ease-in, padding 0.3s ease-in;
}

/* Feedback components */
.feedback-slider {
  background-color: #265d38;
  border-radius: 4px;
  padding: 15px;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

.feedback-size {
  font-size: 1.3rem;
  color: #ffffff;
  margin: 5px 0;
  font-weight: bold;
}

.feedback-content {
  transition: all 0.3s ease-out;
}

.feedback-question {
  font-size: 1.1rem;
  color: #ffffff;
  margin: 5px 0;
  margin-right: 30px;
  font-weight: bold;
}

/* Feedback bar */
.feedback-bar {
  border: 2px solid #ffffff;
  display: flex;
  height: 20px;
  width: 90%;
  margin: 10px 0;
}

.bar-segment {
  height: 100%;
}

.strongly-disagree {
  background-color: #FF4136;
}

.disagree {
  background-color: #FF851B;
}

.neither {
  background-color: #FFDC00;
}

.agree {
  background-color: #2ECC40;
}

.strongly-agree {
  background-color: #0074D9;
}

/* Feedback stats */
.feedback-stats {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.feedback-stats p {
  margin: 5px;
  font-size: 0.9rem;
  color: #ffffff;
  flex: 1 1 45%;
}

/* Slider controls */
.slider-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 15px;
  padding: 0 10px;
}

.slider-controls button {
  background-color: #f2cd01;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 0.8rem;
}

.slider-controls button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.slider-controls span {
  font-size: 0.9rem;
  color: #dedede;
  flex: 0 0 auto;
  white-space: nowrap;
}

/* Animation classes */
.slide-left-out {
  animation: slideLeftOut 0.3s forwards;
}

.slide-right-out {
  animation: slideRightOut 0.3s forwards;
}

.slide-left-in {
  animation: slideLeftIn 0.3s forwards;
}

.slide-right-in {
  animation: slideRightIn 0.3s forwards;
}

@keyframes slideLeftOut {
  from {
    transform: translateX(0%);
    opacity: 1;
  }
  to {
    transform: translateX(-100%);
    opacity: 0;
  }
}

@keyframes slideRightOut {
  from {
    transform: translateX(0%);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}

@keyframes slideLeftIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0%);
    opacity: 1;
  }
}

@keyframes slideRightIn {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0%);
    opacity: 1;
  }
}

/* Button container */
.button-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  width: 100%;
}

.toggle-button {
  background-color: #f2cd01;
  color: #ffffff;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin: 0 10px;
  font-size: 1rem;
}

.toggle-button:hover {
  background-color: #ff851b;
}

.toggle-button.active {
  background-color: #ff851b;
}

/* Loading screen */
.loading-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  background-color: #013020;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #f2cd01;
  animation: spin 1s linear infinite;
}

/* Footer */
.course-page footer {
  text-align: center;
  padding: 20px 0;
  margin-top: 30px;
  border-top: 1px solid #013020;
  color: #e3e3e3;
  font-size: 0.9rem;
  background-color: #013020;
}

/* Animations */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Lecture, Lab, and GPA Card Styles */
.lecture-card,
.lab-card,
.gpa-card {
  background-color: #265d38;
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 8px;
  width: 95%;
  margin-left: auto;
  margin-right: auto;
}

.lecture-card-header,
.lab-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.lecture-card-header h3,
.lab-card-header h3 {
  font-size: 1.2rem;
  color: #ffffff;
  margin: 0;
}

.details-button {
  background-color: #f2cd01;
  color: #ffffff;
  padding: 5px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
}

.details-button:hover {
  background-color: #ff851b;
}

.lecture-card p,
.lab-card p,
.gpa-card p {
  margin: 5px 0;
  color: #e3e3e3;
}

/* Feedback Mini Card */
.feedback-mini-card {
  padding: 10px;
  border-radius: 8px;
  margin-top: 10px;
  background-color: #265d38;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
}

/* Media Queries */
@media screen and (max-width: 600px) {
  .data-table {
    display: none;
  }

  .lecture-card,
  .lab-card,
  .gpa-card {
    display: block;
  }

  .course-page main {
    padding: 0;
  }

  .course-page section {
    padding: 10px;
  }

  .feedback-stats p {
    flex: 1 1 100%;
    margin: 5px 0;
  }

  .feedback-bar {
    height: 15px;
  }

  .lecture-card,
  .lab-card,
  .gpa-card {
    margin-left: auto;
    margin-right: auto;
    width: 95%;
  }

  /* Add yellow border to feedback mini card in mobile view */
  .feedback-mini-card {
    border: 2px solid #f2cd01;
  }
}

@media screen and (min-width: 601px) {
  .lecture-card,
  .lab-card,
  .gpa-card {
    display: none;
  }

  .course-page main {
    padding: 20px;
  }

  .course-page section {
    padding: 20px;
  }

  /* Remove yellow border in desktop view */
  .feedback-mini-card {
    border: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/CoursePage.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,UAAU;EACV,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA,mBAAmB;AACnB;;EAEE,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uDAAuD;EACvD,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,qDAAqD;AACvD;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,yBAAyB;IACzB,UAAU;EACZ;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,UAAU;EACZ;EACA;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,UAAU;EACZ;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,sCAAsC;AACtC;;;EAGE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE;IACE,aAAa;EACf;;EAEA;;;IAGE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;;;IAGE,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;EACZ;;EAEA,2DAA2D;EAC3D;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;;IAGE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA,yCAAyC;EACzC;IACE,YAAY;EACd;AACF","sourcesContent":["/* Root level containment */\nhtml, body {\n  position: relative;\n  width: 100vw;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  -webkit-text-size-adjust: 100%;\n}\n\n/* Container styles */\n.course-page {\n  width: 100%;\n  max-width: 100%;\n  padding: 20px;\n  margin: 0 auto;\n  background-color: #013020;\n  box-shadow: none;\n  border: none;\n  box-sizing: border-box;\n  touch-action: pan-y pinch-zoom;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Header styles */\n.course-page header {\n  text-align: left;\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.course-page header h1 {\n  font-size: 2.8rem;\n  color: #ffffff;\n  margin-bottom: 10px;\n  text-align: left;\n}\n\n.course-page header h2 {\n  font-size: 2.0rem;\n  color: #ffffff;\n  margin: 10px 0;\n}\n\n.course-page header p {\n  font-size: 1.0rem;\n  color: #e3e3e3;\n  margin: 5px 0;\n}\n\n.course-page header .units-description {\n  font-size: 1.2rem;\n  color: #5e5e5e;\n  margin: 5px 0;\n}\n\n/* Content styles */\n.prerequisite,\n.corequisite {\n  font-size: 1.1rem;\n  color: #e3e3e3;\n  margin: 10px 0;\n  padding: 10px;\n  background-color: #1b232b;\n  border-left: 4px solid #f2cd01;\n}\n\n.gpa {\n  color: #f2cd01;\n  margin: 5px 0;\n  font-weight: bold;\n}\n\n/* Main layout */\n.course-page main {\n  margin-top: 20px;\n  background-color: #013020;\n  padding: 20px;\n  border-radius: 8px;\n}\n\n.course-page section {\n  margin-bottom: 30px;\n  background-color: #013020;\n  padding: 20px;\n  border-radius: 8px;\n}\n\n.course-page section h2 {\n  font-size: 1.5rem;\n  color: #ffffff;\n  border-bottom: 2px solid #f2cd01;\n  padding-bottom: 10px;\n  margin-bottom: 15px;\n}\n\n/* Table styles */\n.table-container {\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  position: relative;\n  margin: 0;\n  padding: 0;\n}\n\n.data-table {\n  width: max-content;\n  min-width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  margin-bottom: 20px;\n  background-color: #013020;\n  text-align: center;\n}\n\n.data-table th,\n.data-table td {\n  border: 1px solid #ffffff;\n  padding: 12px 15px;\n  text-align: center;\n  font-size: 0.9rem;\n  color: #e3e3e3;\n  vertical-align: middle;\n}\n\n.data-table th {\n  background-color: #013020;\n  font-weight: bold;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.data-table tr:nth-child(even) {\n  background-color: #178445;\n}\n\n.data-table tr {\n  touch-action: pan-y;\n}\n\n.data-table button {\n  background-color: #f2cd01;\n  color: #ffffff;\n  padding: 5px 10px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  touch-action: manipulation;\n}\n\n.data-table button:hover {\n  background-color: #ff851b;\n}\n\n.data-table td a {\n  color: #fff700;\n  text-decoration: underline;\n}\n\n.data-table td a:hover {\n  text-decoration: underline;\n}\n\n/* Details container styles */\n.details-row {\n  background-color: #265d38;\n}\n\n.details-container {\n  padding: 0;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.5s ease-out, padding 0.3s ease-out;\n  background-color: #265d38;\n  opacity: 0;\n}\n\n.details-container.expanded {\n  opacity: 1;\n  transition: height 0.5s ease-in, padding 0.3s ease-in;\n}\n\n/* Feedback components */\n.feedback-slider {\n  background-color: #265d38;\n  border-radius: 4px;\n  padding: 15px;\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n.feedback-size {\n  font-size: 1.3rem;\n  color: #ffffff;\n  margin: 5px 0;\n  font-weight: bold;\n}\n\n.feedback-content {\n  transition: all 0.3s ease-out;\n}\n\n.feedback-question {\n  font-size: 1.1rem;\n  color: #ffffff;\n  margin: 5px 0;\n  margin-right: 30px;\n  font-weight: bold;\n}\n\n/* Feedback bar */\n.feedback-bar {\n  border: 2px solid #ffffff;\n  display: flex;\n  height: 20px;\n  width: 90%;\n  margin: 10px 0;\n}\n\n.bar-segment {\n  height: 100%;\n}\n\n.strongly-disagree {\n  background-color: #FF4136;\n}\n\n.disagree {\n  background-color: #FF851B;\n}\n\n.neither {\n  background-color: #FFDC00;\n}\n\n.agree {\n  background-color: #2ECC40;\n}\n\n.strongly-agree {\n  background-color: #0074D9;\n}\n\n/* Feedback stats */\n.feedback-stats {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 10px;\n}\n\n.feedback-stats p {\n  margin: 5px;\n  font-size: 0.9rem;\n  color: #ffffff;\n  flex: 1 1 45%;\n}\n\n/* Slider controls */\n.slider-controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n  margin-top: 15px;\n  padding: 0 10px;\n}\n\n.slider-controls button {\n  background-color: #f2cd01;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.slider-controls button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.slider-controls span {\n  font-size: 0.9rem;\n  color: #dedede;\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n/* Animation classes */\n.slide-left-out {\n  animation: slideLeftOut 0.3s forwards;\n}\n\n.slide-right-out {\n  animation: slideRightOut 0.3s forwards;\n}\n\n.slide-left-in {\n  animation: slideLeftIn 0.3s forwards;\n}\n\n.slide-right-in {\n  animation: slideRightIn 0.3s forwards;\n}\n\n@keyframes slideLeftOut {\n  from {\n    transform: translateX(0%);\n    opacity: 1;\n  }\n  to {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n}\n\n@keyframes slideRightOut {\n  from {\n    transform: translateX(0%);\n    opacity: 1;\n  }\n  to {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n}\n\n@keyframes slideLeftIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0%);\n    opacity: 1;\n  }\n}\n\n@keyframes slideRightIn {\n  from {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0%);\n    opacity: 1;\n  }\n}\n\n/* Button container */\n.button-container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.toggle-button {\n  background-color: #f2cd01;\n  color: #ffffff;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin: 0 10px;\n  font-size: 1rem;\n}\n\n.toggle-button:hover {\n  background-color: #ff851b;\n}\n\n.toggle-button.active {\n  background-color: #ff851b;\n}\n\n/* Loading screen */\n.loading-screen {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  background-color: #013020;\n}\n\n.spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border-left-color: #f2cd01;\n  animation: spin 1s linear infinite;\n}\n\n/* Footer */\n.course-page footer {\n  text-align: center;\n  padding: 20px 0;\n  margin-top: 30px;\n  border-top: 1px solid #013020;\n  color: #e3e3e3;\n  font-size: 0.9rem;\n  background-color: #013020;\n}\n\n/* Animations */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Lecture, Lab, and GPA Card Styles */\n.lecture-card,\n.lab-card,\n.gpa-card {\n  background-color: #265d38;\n  padding: 15px;\n  margin-bottom: 20px;\n  border-radius: 8px;\n  width: 95%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.lecture-card-header,\n.lab-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.lecture-card-header h3,\n.lab-card-header h3 {\n  font-size: 1.2rem;\n  color: #ffffff;\n  margin: 0;\n}\n\n.details-button {\n  background-color: #f2cd01;\n  color: #ffffff;\n  padding: 5px 10px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.details-button:hover {\n  background-color: #ff851b;\n}\n\n.lecture-card p,\n.lab-card p,\n.gpa-card p {\n  margin: 5px 0;\n  color: #e3e3e3;\n}\n\n/* Feedback Mini Card */\n.feedback-mini-card {\n  padding: 10px;\n  border-radius: 8px;\n  margin-top: 10px;\n  background-color: #265d38;\n  box-sizing: border-box;\n  width: 100%;\n  overflow: hidden;\n}\n\n/* Media Queries */\n@media screen and (max-width: 600px) {\n  .data-table {\n    display: none;\n  }\n\n  .lecture-card,\n  .lab-card,\n  .gpa-card {\n    display: block;\n  }\n\n  .course-page main {\n    padding: 0;\n  }\n\n  .course-page section {\n    padding: 10px;\n  }\n\n  .feedback-stats p {\n    flex: 1 1 100%;\n    margin: 5px 0;\n  }\n\n  .feedback-bar {\n    height: 15px;\n  }\n\n  .lecture-card,\n  .lab-card,\n  .gpa-card {\n    margin-left: auto;\n    margin-right: auto;\n    width: 95%;\n  }\n\n  /* Add yellow border to feedback mini card in mobile view */\n  .feedback-mini-card {\n    border: 2px solid #f2cd01;\n  }\n}\n\n@media screen and (min-width: 601px) {\n  .lecture-card,\n  .lab-card,\n  .gpa-card {\n    display: none;\n  }\n\n  .course-page main {\n    padding: 20px;\n  }\n\n  .course-page section {\n    padding: 20px;\n  }\n\n  /* Remove yellow border in desktop view */\n  .feedback-mini-card {\n    border: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
